import { render, staticRenderFns } from "./divider.vue?vue&type=template&id=2b59e2ef&"
import script from "./divider.vue?vue&type=script&lang=ts&"
export * from "./divider.vue?vue&type=script&lang=ts&"
import style0 from "./divider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports